import { a11yProps, sizeTab, } from "@/shared";
import { CustomNote, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { CustomTabPanel } from "@/erp/sale";
import KardexPorProducto from "./componente/KardexPorProducto";
import KardexPorBodega from "./componente/KardexPorBodega";
import KardexPorSerie from "./componente/KardexPorSerie";
import ModalKardexSeries from "./componente/ModalKardexSeries";
import ExcelDownloadLoader from "./componente/ExcelDownloadLoader";

export default function KardexPage() {


  //useLoaders(isLoadingKardex);

  const [valueTab, setValueTab] = useState(0);

  return (
    <>

      <SingleTableBoxScene
        title="📓Kardex"
        visibleReport={false}
      >
        <CustomNote
          note="Sistema de gestión de inventario y control de bodega."
        />
        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, padding: '10px 0px' }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preventa"
          >
            <Tab label={'Por Producto'} {...a11yProps(0)} />
            <Tab label={'Por Bodega'} {...a11yProps(1)} />
            <Tab label={'Por Serie'} {...a11yProps(2)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTab} index={0}>
          <KardexPorProducto />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <KardexPorBodega />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <KardexPorSerie />
        </CustomTabPanel>

      </SingleTableBoxScene>

      <ModalKardexSeries />
      <ExcelDownloadLoader />

    </>
  );

}